module.exports = __webpack_public_path__ + "static/media/Hoopers01.bc5b9380.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Hoopers01.jpg
// module id = 350
// module chunks = 0